// extracted by mini-css-extract-plugin
export default {"availableUnits":"_36_Ae70J7FZgPR891WgpzV"};